import styled from 'styled-components';

export const OptionWrapper = styled.div`
    padding: 1.6rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
export const OptionWrapperLeft = styled.div`
    flex: 1;
    .optionList{
        display: flex;
        flex-wrap: wrap;
        >li {
            display: flex;
            align-items: center;
            height: 2.4rem;
            border-radius: 0.8rem;
            border: solid 0.1rem #e5edf6;
            padding: 0 0.9rem 0 0.2rem;
            margin-right: 1.5rem;
            margin-top: 1rem;
            .liquid {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                height: 1.8rem;
                border-radius: 0.6rem;
                padding: 0 0.5rem;
                background-image: linear-gradient(90deg, #34393a, #adaeb2);
                font-family: 'Rubik';
                font-weight: 600;
                font-size: 1.2rem;                
                margin-right: 0.7rem;
            }
            >span:last-child{
                color: #2276e3;
                font-weight: 600;
                font-size: 1.4rem;
            }
        }
    }
`;
export const OptionWrapperRight = styled.div`
    flex-shrink: 0;
    margin-left: auto;
    .btnToggle {
        font-family: 'Rubik';
        font-size: 1.6rem;
        color: #2276e3;
        display: flex;
        align-items: center;
        font-weight: 600;
        cursor: pointer;
        ::after{
            content: "";
            border: solid #2276e3;
            border-width: 0 0.2rem 0.2rem 0;
            padding: 0.4rem;
            transform: rotate(45deg);
            margin-left: 1rem;
            margin-top: -0.5rem;
        }
    }

    .toggleUp {
        ::after{
            transform: rotate(-135deg);
            transition: transform 0.3s;
            margin-top: 0.4rem;
        }
    }
`;
export const InfoText = styled.p`
    font-size: 1.4rem;
    line-height: 2.2rem;
    font-family: 'Rubik';
    color: #2f2f2f;
    b {
        font-weight: 600;
    }
    > span{
        font-weight: 600;
    }
`;